module.exports = __webpack_public_path__ + "fonts/deposit-guide-1-KVND.91da6082s.png";